$(document).ready(function() {

  var lastScroll = 0;
  var pageHeader = $(".page-header");
  var pageMain = $(".page-main");
  var masterBar = $(".master-container");
  var megaDropdown = $(".mega-dropdown");
  var masterHeight;
  var searchInputContainer = $(".search-container");
  var searchContainer = $(".search-container");
  var headerSearch = $(".mobile-header-search");

  pageHeader.removeClass("mobile").css("margin-top", 0);

  if(window.location.pathname.split("/")[2] !== 'search-results-page') {

    $(window).on('scroll', function (){

      var scroll = $(window).scrollTop();
      megaDropdown.removeClass('hovered');
      var masterHeight = masterBar.height();

      if (scroll > lastScroll) {

        if( Foundation.MediaQuery.current == 'small' || Foundation.MediaQuery.current == 'medium' ) {


            if (scroll > 300) {

              // Scroll down pass 300px
              masterBar.addClass("fixed indexed");
              pageHeader.removeClass("mobile fixed");
              pageHeader.addClass("normal").css({"margin-top": 0, "top":0});
              pageMain.addClass('page-main-2');
              headerSearch.removeClass("slideDown");

            }


        } else {

            masterBar.addClass("fixed indexed");
            pageHeader.removeClass("mobile fixed");
            pageHeader.addClass("normal").css({"margin-top": 0, "top":0});
            pageMain.addClass('page-main-2');
            headerSearch.removeClass("slideDown");

        }


      } else if (scroll < lastScroll) {

          // Scroll up
          masterBar.addClass("fixed");
          pageHeader.addClass("mobile");
          pageHeader.removeClass("normal").css("margin-top",masterHeight);
          pageMain.addClass('page-main-2');

      }

      lastScroll = scroll;

      if (scroll <= 0 ) {

          // Scrollbar position is top
          masterBar.removeClass("fixed indexed");
          pageHeader.removeClass("mobile");
          pageHeader.removeClass("normal").css({"margin-top": 0, "top":0});
          pageMain.removeClass('page-main-2');

      }

    });

  }

});
